import * as Types from './machineStandStillActionTypes.js';
import { produce } from 'immer';

const initialState = {
    machineStandStillInfo: []
};

export default function machineStandStill(state = initialState, action) {
    return produce(state, draft => {
        switch (action.type) {
            case Types.SET_MACHINESTANDSTILLINFO:
                if (draft.machineStandStillInfo !== action.machineStandStillInfo) {
                    // console.log("MachineStandStillInfo updated", action.machineStandStillInfo);
                    // draft.machineStandStillInfo = action.machineStandStillInfo;
                    return Object.assign({}, state, { machineStandStillInfo: action.machineStandStillInfo });

                }
                return state;
            default:
                return draft;
        }
    });
}